/**
 * Animation configuration constants
 * Used across all animation hooks for consistency
 */

export const ANIMATION = {
  duration: {
    fast: 0.6,
    normal: 1.0,
    slow: 1.2,
    typing: 0.05, // Per character
  },
  ease: {
    reveal: 'power3.out',
    bounce: 'back.out(1.7)',
    elastic: 'elastic.out(1, 0.3)',
    smooth: 'power2.out',
  },
  distance: {
    short: 40,
    normal: 60,
    long: 80,
  },
  blur: {
    light: 4,
    normal: 8,
    heavy: 12,
  },
  stagger: {
    fast: 0.1,
    normal: 0.15,
    slow: 0.2,
  },
  scale: {
    subtle: 0.97,
    normal: 0.95,
    dramatic: 0.9,
  },
} as const

/**
 * Direction config for directional reveals
 */
export const DIRECTION_CONFIG = {
  top: { y: -ANIMATION.distance.normal, x: 0 },
  right: { x: ANIMATION.distance.normal, y: 0 },
  bottom: { y: ANIMATION.distance.normal, x: 0 },
  left: { x: -ANIMATION.distance.normal, y: 0 },
  fade: { x: 0, y: 0 },
} as const

export type Direction = keyof typeof DIRECTION_CONFIG

/**
 * Check if user prefers reduced motion
 */
export function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined') return false
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}
